import { ActionTree } from "vuex";
import { ConfigState } from "./types";
import { RootState } from "../types";
import axios from "axios";

export const actions: ActionTree<ConfigState, RootState> = {
	settoken(commit, token: string) {
		commit.commit("settoken", token);
	},
	setuser(commit, user: string) {
		commit.commit("setuser", user);
	},
	setapiroot(commit, apiroot: string) {
		axios.defaults.baseURL = apiroot;
		commit.commit("setapiroot", apiroot);
	},
	setcurrentid(commit, currentid: number) {
		commit.commit("setcurrentid", currentid);
	},
	setaccountid(commit, accountid: number) {
		commit.commit("setaccountid", accountid);
	},
	setthumburl(commit, thumburl: string) {
		commit.commit("setthumburl", thumburl);
	},
	setstore(commit, store: string) {
		commit.commit("setstore", store);
	},
	setadmin(commit, store: boolean) {
		commit.commit("setadmin", store);
	}
};
